module.exports = __webpack_public_path__ + "media/assets/images/favicon-156bbb7348f34b6d7136b49f5b1c63b6.ico";